var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.644 4.79999H20.544C22.044 4.79999 22.8 5.50799 22.8 6.94799V17.052C22.8 18.48 22.044 19.2 20.544 19.2H4.644C3.144 19.2 2.388 18.48 2.388 17.052V6.94799C2.388 5.50799 3.144 4.79999 4.644 4.79999ZM12.588 15.12L20.676 8.48399C20.964 8.24399 21.192 7.69199 20.832 7.19999C20.484 6.70799 19.848 6.69599 19.428 6.99599L12.588 11.628L5.76 6.99599C5.34 6.69599 4.704 6.70799 4.356 7.19999C3.996 7.69199 4.224 8.24399 4.512 8.48399L12.588 15.12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.4d35e9eb37ba0de432cbf799959f77ad.svg";
export { ForwardRef as ReactComponent };